<template>
  <div class="CardChar DashScrollContainer">
    <div
      class="DashScrollContainer pointer"
      @click="isCollapse ? (show = !show) : null"
    >
      <CampoRecursivo
        v-for="(campo, i) of estructura.campos"
        :key="i"
        :_key="`${i}`"
        :data="item"
        :campo="campo"
      />

      <div v-if="isCollapse && show" class="DetalleCollapse">
        <div
          v-for="(detalle, i) of item.detalle"
          :key="`detalle_${i}`"
          class="DashScrollContainer"
        >
          <CampoRecursivo
            v-for="(campo, indx) of estructura.detalles"
            :key="indx"
            :_key="`${indx}`"
            :data="detalle"
            :campo="campo"
          />
        </div>

        <div class="DashScrollContainer ">
          <i class="fa fa-chevron-up" style="font-size: 18px;color: #fff"></i>
        </div>
      </div>

      <div v-if="isCollapse && !show" class="DashScrollContainer text-center">
        <i class="fa fa-chevron-down" style="font-size: 18px;color: #fff"></i>
      </div>
    </div>

    <router-link
      v-if="item.subGrafica"
      :to="{
        name: 'AnalyticsChart',
        params: { ...item.subGrafica, goBack }
      }"
      class="subGrafica"
    >
      <p class="subGraficaFont">
        Ver detalle
        <i class="fa fa-chevron-right" style="font-size: 18px;color: #fff"></i>
      </p>
    </router-link>
  </div>
</template>

<script>
import CampoRecursivo from "./CampoRecursivo.vue";
export default {
  name: "RenderItem",
  components: {
    CampoRecursivo
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    estructura: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    goBack() {
      return this.$route?.params;
    },
    isCollapse() {
      return this.item.detalle.length > 0;
    }
  },
  data() {
    return {
      show: false
    };
  }
};
</script>

<style lang="scss" scoped>
.DetalleCollapse {
  width: 100%;
  border-top: 1px solid #fff;
  margin-top: 5px;
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
}
.CardChar {
  background-color: #fb8e2c;
  border-radius: 16px;
  padding: 8px;
  margin-top: 8px;
  margin-bottom: 4px;
  max-width: 400px;
  margin-left: 8px;
  margin-right: 8px;
}
.DashScrollContainer {
  & > * {
    display: flex;
    flex-direction: column;
  }
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-evenly;
}
.subGrafica {
  border-top: 1px solid #fff;
  width: 100%;
  justify-content: center;
  align-items: center;
  height: 30px;
  margin-top: 12px;
  &:hover {
    text-decoration: none;
  }
}
.subGraficaFont {
  font-weight: bold;
  text-align: center;
  color: #fff;
  font-size: 20px;
  margin-bottom: 0;
}
</style>
